import type { ApiErrorPayload } from '@/shared/types/api';

/**
 * Typed error matching the backend error envelope (DEC-025).
 * Always thrown from `api-client` when the response carries `{ success: false }`.
 */
export class ApiError extends Error {
  readonly code: string;
  readonly status: number;
  readonly details: unknown;
  readonly requestId: string | undefined;

  constructor(
    payload: ApiErrorPayload,
    options: { status: number; requestId?: string | undefined },
  ) {
    super(payload.message);
    this.name = 'ApiError';
    this.code = payload.errorCode;
    this.status = options.status;
    this.details = payload.details;
    this.requestId = options.requestId;
  }
}

/**
 * Thrown when the network layer itself fails (no Response was produced, or
 * the response could not be parsed as JSON).
 */
export class ApiNetworkError extends Error {
  readonly cause: unknown;

  constructor(message: string, cause?: unknown) {
    super(message);
    this.name = 'ApiNetworkError';
    this.cause = cause;
  }
}
